module.exports = __webpack_public_path__ + "static/img/loading_img.0784382.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/loading_img.gif
// module id = xAJx
// module chunks = 104